import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-theatre-ink" data-testid="auth-loading">
        <Loader2 className="animate-spin text-theatre-gold" size={32} />
      </div>
    );
  }
  if (user === false) return <Navigate to="/admin/login" replace />;
  return children;
};
